{% block acris_faq_keyword_modal_form %}
    <div class="acris-faq-keyword-modal-form">

        {% block acris_faq_keyword_modal_form_matching_type_info %}
            <mt-banner variant="info" v-html="$tc('acris-faq.detail.fieldTitleInfoMatchingType')">
            </mt-banner>
        {% endblock %}

        {% block acris_faq_keyword_modal_form_matching_type %}
            <mt-select :label="$tc('acris-faq.detail.fieldTitleLabelMatchingType')"
                       @change="changeMatchingType"
                       :options="optionsKeywordMatchType"
                       v-model="keyword.matchingType">
            </mt-select>
        {% endblock %}

        {% block acris_faq_keyword_modal_form_strict %}
            <mt-text-field
                    required
                    v-if="keyword.matchingType == 'strict'"
                    class="acris-faq-keyword-modal-field-name"
                    :label="$tc('acris-faq.detail.fieldTitleLabelKeywordName')"
                    :helpText="$tc('acris-faq.detail.fieldTitleHelpTextMatchingType')"
                    :placeholder="$tc('acris-faq.detail.fieldKeywordPlaceholder')"
                    v-model="keyword.name">
            </mt-text-field>
        {% endblock %}

        {% block acris_faq_keyword_modal_form_field_regex %}
            <mt-text-field
                    required
                    v-if="keyword.matchingType == 'regex'"
                    class="acris-faq-keyword-modal-field-name"
                    :label="$tc('acris-faq.detail.fieldOptionLabelMatchingTypeRegex')"
                    :helpText="$tc('acris-faq.detail.fieldTitleHelpTextRegex')"
                    :placeholder="$tc('acris-faq.detail.fieldTitlePlaceholderRegex')"
                    v-model="keyword.name">
            </mt-text-field>
        {% endblock %}
    </div>
{% endblock %}
